import axiosClient from "axios-client";

import { setStringValue, setObjectValue, clearStorage } from "commons/storage";
import { setErrorMessage } from "context";
import {
  FORGET_PASSWORD_REQUEST,
  FORGET_PASSWORD_FAILED,
  RESET_PASSWORD_SUCCESS,
  GET_QUOTE_REQUEST,
  SUPPORT_USER_REQUEST,
  CHECK_NDA_SUCCESS,
  CHECK_NDA_FAILED,
  CONTACT_US_SUCCESS,
  CHANGE_PASSWORD_REQUEST,
  CHANGE_PASSWORD_FAILED,
  REQUEST_GITHUB_SUCCESS,
  UPDATE_USER_STATUS_REQUEST,
  UPDATE_USER_STATUS_FAILED,
  UPDATE_API_STATUS_REQUEST,
  UPDATE_API_STATUS_FAILED,
  CREATE_USER_FAILED,
  CREATE_USER_SUCCESS,
  CREATE_USER_REQUEST,
  UPDATE_API_STATUS_SUCCESS,
  UPDATE_USER_STATUS_SUCCESS,
  REQUEST_GITHUB_FAILED,
  REQUEST_GITHUB_REQUEST,
  CHANGE_PASSWORD_SUCCESS,
  CONTACT_US_FAILED,
  CONTACT_US_REQUEST,
  CHECK_NDA_REQUEST,
  GET_QUOTE_FAILED,
  GET_QUOTE_SUCCESS,
  SUPPORT_USER_SUCCESS,
  SUPPORT_USER_FAILED,
  RESET_PASSWORD_FAILED,
  RESET_PASSWORD_REQUEST,
  FORGET_PASSWORD_SUCCESS,
  LOGOUT,
  LOGIN_FAILED,
  LOGIN_SUCCESS,
  LOGIN_REQUEST,
  ADMIN_LOGIN_REQUEST,
  QUESTIONNAIRE_SUCESS,
  QUESTIONNAIRE_FAILED,
  SUPPORT_USER_TICKETS,
  REGISTER_REQUEST,
  REGISTER_SUCCESS,
  REGISTER_FAILED,
  SEND_EMAIL_MODAL,
  RECENT_EMAIL_MODAL,
} from "redux/constants";

export const EndPoints = {
  ADMIN_LOGIN: "/API/Authenticate/AdminLoginIn",
  LOGIN: "/API/Authenticate/login",
  REGISTER: "/API/Authenticate/User-Registration",
  FORGET_PASSWORD: "/API/Authenticate/forgetpwd",
  RESET_PASSWORD: "/API/Authenticate/forgetpwdupdate",
  REQUEST_NEW_API: "/API/APIManagement/RequestNewAPI",
  GET_CUSTOMER_APIS: "/API/APIManagement/GetCustomerAPIS",
  GET_QUOTE: "/API/APIManagement/GetQuote",
  CHECK_NDA: "/API/Authenticate/NDAProcess",
  CONTACT_US: "/API/Authenticate/ContactUs",
  CHANGE_PASSWORD: "/API/Account/updatepassword",
  REQUEST_GITHUB_ACCESS: "/API/Authenticate/RepositoryRequest",
  GET_ALL_USERS: "/API/RM/GetAllUser",
  GET_ALL_USERS_WITH_SANDBOX: "/API/RM/GetAllUser_Sandbox",
  UPDATE_USER_STATUS: "/API/RM/UpdateUserAccount",
  GET_REQUESTED_QUOTES: "/API/RM/GetRequestedQuote",
  GET_ACCESS_REQUESTS: "/API/RM/GetAPI",
  SUPPORT_USER: "/API/Support/CreateSupportItem",
  GET_ALL_SUPPORT_ITEM: "/API/Support/ShowSupportItem",
  UPDATE_API_STATUS: "/API/RM/UpdateAPIStatus",
  UPDATE_API_STATUS_TECH: "/API/RM/UpdateAPIStatus_Tech",
  UPDATE_PRODUCTION_API_STATUS: "/API/RM/UpdateAPIProduction",
  CREATE_USER: "/API/RM/UserCreation",
  GET_ALL_ROLES: "/API/RM/GetGroup",
  GET_ALL_STATISTICS_RM: "/API/RM/GetStatistic",
  REJECT_PRODUCTION_REQUEST: "/API/RM/RejectProductionRequest",
  UPDATE_SUPPORT_STATUS: "API/Support/UpdateSupportStatus",
  GET_NOTIFICATION: "/API/Notification/GetNotification",
  UPDATE_NOTIFICATION: "/API/Notification/UpdateNotification",
  MARK_ALL_NOTIFICATION_VIEWED: "/API/Notification/MarkViewedAllNotification",
  GET_NOTIFICATION_COUNT: "/API/Notification/GetNotificationCount",
  QUESTIONNAIRE: "/API/Authenticate/RequestAPIQuestionnaire",
  QUESTIONNAIRE_PRODUCTION: "/API/Authenticate/RequestAPIQuestionnaire",
  SUPPORT_USER_TICKETS: "/API/Support/ShowUserSpecificSupportItem",
  SUPPORT_FILE_DOWNLOAD: "/api/Support/DownloadFiles",
  ONBOARDING_FORM: "/API/RM/GetAPIQuestionnaireDetail",
  REQUEST_BULK_API_SANDBOX: "/API/APIManagement/RequestBulkAPIs",
  REQUEST_DELETE_DATA: "/API/Authenticate/RequestDataDelete",
  AUDIT_TRAIL: "/API/AuditTrail/GetAuditLogs",
  AUDIT_TRAIL_DOWNLOAD: "/API/AuditTrail/DownloadAuditLogs",
  SEND_EMAIL_MODAL: "/API/RM/SendUserEmail",
  RECENT_EMAIL_MODAL: "/API/RM/ViewUserEmails",
  RECENT_EMAIL_ATTACHMENT_DOWNLOAD: "/API/RM/DownloadUserEmailAttachment",
};

export const Register = (
  dispatch,
  data,
  navigate,
  setShowErrorMessage,
  clearFields,
  setApiResults = null
) => {
  if (
    data.FirstName &&
    data.LastName &&
    data.Email &&
    data.JobRole &&
    data.apirequestaccessItem &&
    data.Password
  ) {
    dispatch({ type: REGISTER_REQUEST });
    axiosClient
      .post(EndPoints.REGISTER, data)
      .then((res) => {
        dispatch({ type: REGISTER_SUCCESS, payload: res });

        // Check if response contains array of API results
        if (res.data && Array.isArray(res.data) && setApiResults) {
          const successfulApis = res.data.filter(
            (api) => api.status === "Success"
          );
          const failedApis = res.data.filter((api) => api.status === "Error");

          // If there are both successful and failed APIs, show results on signup page
          if (successfulApis.length > 0 && failedApis.length > 0) {
            setApiResults({
              successful: successfulApis,
              failed: failedApis,
              showResults: true,
            });
            return; // Don't navigate away, stay on signup page
          }

          // If all APIs failed, show error message and stay on signup page
          if (successfulApis.length === 0 && failedApis.length > 0) {
            setApiResults({
              successful: [],
              failed: failedApis,
              showResults: true,
            });
            return;
          }

          // If all APIs succeeded, show results on signup page
          if (successfulApis.length > 0 && failedApis.length === 0) {
            setApiResults({
              successful: successfulApis,
              failed: [],
              showResults: true,
            });
            return;
          }
        }

        // Original behavior for complete success or old response format
        navigate();
        clearFields();
      })
      .catch((err) => {
        dispatch({ type: REGISTER_FAILED });
        console.log(err.response.data.message);
        setShowErrorMessage(err.response.data.message);
      });
  }
};

export const Login = (
  dispatch,
  data,
  navigateToDashboard,
  setShowErrorMessage,
  clearFields
) => {
  if (data.UserName && data.Password) {
    dispatch({ type: LOGIN_REQUEST });
    axiosClient
      .post(EndPoints.LOGIN, data)
      .then((res) => {
        let data = {
          user_data: res.data.userInfo,
          token: res.data.token,
          token_validity: res.data.expiration,
        };

        dispatch({ type: LOGIN_SUCCESS, payload: data });

        setObjectValue("user_data", data.user_data);
        setStringValue("token", data.token);
        setStringValue("token_validity", data.token_validity);
        clearFields();
        navigateToDashboard(data.user_data);
      })
      .catch((err) => {
        dispatch({ type: LOGIN_FAILED });
        console.log(err.response.data.message);
        setShowErrorMessage(err.response.data.message);
      });
  }
};

export const AdminLogin = (
  dispatch,
  data,
  navigateToDashboard,
  setShowErrorMessage,
  clearFields
) => {
  if (data.UserName && data.Password) {
    dispatch({ type: ADMIN_LOGIN_REQUEST });
    axiosClient
      .post(EndPoints.ADMIN_LOGIN, data)
      .then((res) => {
        let data = {
          user_data: res.data.userInfo,
          token: res.data.token,
          token_validity: res.data.expiration,
        };

        dispatch({ type: LOGIN_SUCCESS, payload: data });

        setObjectValue("user_data", data.user_data);
        setStringValue("token", data.token);
        setStringValue("token_validity", data.token_validity);
        clearFields();
        navigateToDashboard();
      })
      .catch((err) => {
        dispatch({ type: LOGIN_FAILED });
        console.log(err.response.data.message);
        setShowErrorMessage(err.response.data.message);
      });
  }
};

export const ForgetPasswordAPI = (
  dispatch,
  data,
  success,
  setShowErrorMessage,
  clearFields
) => {
  if (data.email) {
    dispatch({ type: FORGET_PASSWORD_REQUEST });
    axiosClient
      .post(EndPoints.FORGET_PASSWORD, data)
      .then((res) => {
        dispatch({ type: FORGET_PASSWORD_SUCCESS, payload: data });
        clearFields();
        success();
      })
      .catch((err) => {
        dispatch({ type: FORGET_PASSWORD_FAILED });
        console.log(err.response.data.message);
        setShowErrorMessage(err.response.data.message);
      });
  }
};

export const ResetPasswordAPI = (
  dispatch,
  data,
  success,
  setShowErrorMessage,
  clearFields
) => {
  if (data.newPassword && data.token) {
    dispatch({ type: RESET_PASSWORD_REQUEST });
    axiosClient
      .post(EndPoints.RESET_PASSWORD, data)
      .then((res) => {
        dispatch({ type: RESET_PASSWORD_SUCCESS, payload: data });
        clearFields();
        success();
      })
      .catch((err) => {
        dispatch({ type: RESET_PASSWORD_FAILED });
        console.log(err.response.data.message);
        setShowErrorMessage(err.response.data.message);
      });
  }
};

export const Logout = (dispatch, navigate) => {
  clearStorage();
  dispatch({ type: LOGOUT });
  navigate("/");
};

export const RequestNewAPI = (dispatch, data, success, setShowErrorMessage) => {
  if (
    data.customerID &&
    data.apiID &&
    data.apiName &&
    data.userEmail &&
    data.password
  ) {
    axiosClient
      .post(EndPoints.REQUEST_NEW_API, data)
      .then((res) => {
        success(res);
      })
      .catch((err) => {
        setShowErrorMessage(err.response.data.message);
      });
  }
};

export const GetCustomerAPIs = (
  dispatch,
  customerID,
  success,
  setShowErrorMessage
) => {
  if (customerID) {
    axiosClient
      .get(
        EndPoints.GET_CUSTOMER_APIS +
          "?CustomerID=" +
          customerID +
          "&NotApproved=false"
      )
      .then((res) => {
        success(res);
      })
      .catch((err) => {
        console.log(err.response.data.message);
        setShowErrorMessage(err.response.data.message);
      });
  }
};

export const GetCustomerNotApprovedAPIs = (
  dispatch,
  customerID,
  success,
  setShowErrorMessage
) => {
  if (customerID) {
    axiosClient
      .get(
        EndPoints.GET_CUSTOMER_APIS +
          "?CustomerID=" +
          customerID +
          "&NotApproved=true"
      )
      .then((res) => {
        success(res);
      })
      .catch((err) => {
        console.log(err.response.data.message);
        setShowErrorMessage(err.response.data.message);
      });
  }
};

export const GetQuoteAPI = (
  dispatch,
  data,
  success,
  setShowErrorMessage,
  clearFields
) => {
  if (
    data.apiID &&
    data.customerID &&
    data.remarks &&
    data.apiName &&
    data.userEmail
  ) {
    dispatch({ type: GET_QUOTE_REQUEST });
    axiosClient
      .post(EndPoints.GET_QUOTE, data)
      .then((res) => {
        dispatch({ type: GET_QUOTE_SUCCESS, payload: data });
        clearFields();
        success();
      })
      .catch((err) => {
        dispatch({ type: GET_QUOTE_FAILED });
        setShowErrorMessage(err.response.data.message);
      });
  }
};

export const SupportUserAPI = (
  dispatch,
  data,
  config,
  success,
  setShowErrorMessage,
  clearFields
) => {
  dispatch({ type: SUPPORT_USER_REQUEST });
  axiosClient
    .post(EndPoints.SUPPORT_USER, data, config)
    .then((res) => {
      dispatch({ type: SUPPORT_USER_SUCCESS, payload: data });
      clearFields();
      success();
    })
    .catch((err) => {
      dispatch({ type: SUPPORT_USER_FAILED });
      setShowErrorMessage(err.response.data.message);
    });
};

export const CheckNDA = (dispatch, data, success, setShowErrorMessage) => {
  if (data.email) {
    dispatch({ type: CHECK_NDA_REQUEST });
    axiosClient
      .get(EndPoints.CHECK_NDA + "?Email=" + data.email)
      .then((res) => {
        dispatch({ type: CHECK_NDA_SUCCESS });
        success(res);
      })
      .catch((err) => {
        dispatch({ type: CHECK_NDA_FAILED });
        if (err?.response?.data?.status === "new") {
          setShowErrorMessage(
            "Please submit the NDA, by clicking the above link!"
          );
        } else if (err?.response?.status === "500") {
          setErrorMessage("Internal Server Error");
        } else {
          setShowErrorMessage(err?.response?.data);
        }
      });
  }
};

export const ContactUs = (dispatch, data, success, failure, clearFields) => {
  if (data.body) {
    dispatch({ type: CONTACT_US_REQUEST });
    axiosClient
      .post(EndPoints.CONTACT_US, data)
      .then((res) => {
        dispatch({ type: CONTACT_US_SUCCESS });
        clearFields();
        success();
      })
      .catch((err) => {
        dispatch({ type: CONTACT_US_FAILED });
        failure(err.response.data.message);
      });
  }
};

export const ChangePassword = (
  dispatch,
  data,
  success,
  failure,
  clearFields
) => {
  if (data.password) {
    dispatch({ type: CHANGE_PASSWORD_REQUEST });
    axiosClient
      .post(EndPoints.CHANGE_PASSWORD, data)
      .then((res) => {
        console.log(res);
        dispatch({ type: CHANGE_PASSWORD_SUCCESS });
        clearFields();
        success();
      })
      .catch((err) => {
        dispatch({ type: CHANGE_PASSWORD_FAILED });
        failure(err.response.data.message);
      });
  }
};

export const RequestGitHubAccess = (
  dispatch,
  data,
  success,
  setShowErrorMessage,
  clearFields
) => {
  if (data.repositoryName && data.email) {
    dispatch({ type: REQUEST_GITHUB_REQUEST });
    axiosClient
      .post(EndPoints.REQUEST_GITHUB_ACCESS, data)
      .then((res) => {
        dispatch({ type: REQUEST_GITHUB_SUCCESS, payload: data });
        clearFields();
        success();
      })
      .catch((err) => {
        dispatch({ type: REQUEST_GITHUB_FAILED });
        clearFields();
        console.log(err.response.data.message);
        setShowErrorMessage(err.response.data.message);
      });
  }
};

export const GetAllUsers = async (
  dispatch,
  success,
  setShowErrorMessage,
  filter = "",
  role = "",
  status = ""
) => {
  let url = EndPoints.GET_ALL_USERS;
  if (filter != "") {
    url = url + "?filter=" + filter;
  }
  if (role != "" && filter != "") {
    url = url + "&role=" + role;
  } else if (role != "") {
    url = url + "?role=" + role;
  }

  let params = {};

  if (filter != "") {
    params["filter"] = filter;
  }

  if (role != "") {
    params["role"] = role;
  }

  if (status != "") {
    params["status"] = status;
  }

  await axiosClient
    .get(url, { params })
    .then((res) => {
      success(res);
    })
    .catch((err) => {
      console.log(err.response.data.message);
      setShowErrorMessage(err.response.data.message);
    });
};

export const UpdateUserStatus = async (
  dispatch,
  data,
  success,
  setShowErrorMessage
) => {
  dispatch({ type: UPDATE_USER_STATUS_REQUEST });
  await axiosClient
    .post(EndPoints.UPDATE_USER_STATUS, data)
    .then((res) => {
      dispatch({ type: UPDATE_USER_STATUS_SUCCESS });
      success(res);
    })
    .catch((err) => {
      dispatch({ type: UPDATE_USER_STATUS_FAILED });
      console.log(err.response.data.message);
      setShowErrorMessage(err.response.data.message);
    });
};

export const GetRequestedQuotes = async (
  dispatch,
  success,
  setShowErrorMessage,
  filter = ""
) => {
  let url = EndPoints.GET_REQUESTED_QUOTES;
  if (filter != "") {
    url = url + "?filter=" + filter;
  }

  await axiosClient
    .get(url)
    .then((res) => {
      success(res);
    })
    .catch((err) => {
      console.log(err.response.data.message);
      setShowErrorMessage(err.response.data.message);
    });
};

export const GetAllSupportItem = async (
  dispatch,
  success,
  setShowErrorMessage,
  filter = ""
) => {
  let url = EndPoints.GET_ALL_SUPPORT_ITEM;
  if (filter != "") {
    url = url + "?filter=" + filter;
  }
  await axiosClient
    .get(url)
    .then((res) => {
      success(res);
    })
    .catch((err) => {
      console.log(err.response.data.message);
      setShowErrorMessage(err.response.data.message);
    });
};

export const GetAccessRequests = async (
  dispatch,
  success,
  setShowErrorMessage,
  filter = "",
  status = ""
) => {
  let url = EndPoints.GET_ACCESS_REQUESTS;
  if (filter != "") {
    url = url + "?filter=" + filter;
  }

  if (status != "" && filter != "") {
    url = url + "&status=" + status;
  } else if (status != "") {
    url = url + "?status=" + status;
  }

  await axiosClient
    .get(url)
    .then((res) => {
      success(res);
    })
    .catch((err) => {
      console.log(err.response.data.message);
      setShowErrorMessage(err.response.data.message);
    });
};

export const GetProductionRequests = async (
  dispatch,
  success,
  setShowErrorMessage,
  filter = "",
  status = ""
) => {
  let url = EndPoints.GET_REQUESTED_QUOTES;
  if (filter != "") {
    url = url + "?filter=" + filter;
  }

  if (status != "" && filter != "") {
    url = url + "&status=" + status;
  } else if (status != "") {
    url = url + "?status=" + status;
  }

  await axiosClient
    .get(url)
    .then((res) => {
      success(res);
    })
    .catch((err) => {
      console.log(err.response.data.message);
      setShowErrorMessage(err.response.data.message);
    });
};

export const UpdateAPIStatus = async (
  dispatch,
  data,
  setUpdateSuccess,
  setShowErrorMessage
) => {
  dispatch({ type: UPDATE_API_STATUS_REQUEST });
  await axiosClient
    .post(EndPoints.UPDATE_API_STATUS, data)
    .then((res) => {
      dispatch({ type: UPDATE_API_STATUS_SUCCESS });
      console.log(res);
      setUpdateSuccess(res);
    })
    .catch((err) => {
      dispatch({ type: UPDATE_API_STATUS_FAILED });
      setShowErrorMessage(err.response.data);
    });
};

export const UpdateProductionAPIStatus = async (
  dispatch,
  data,
  success,
  setShowErrorMessage
) => {
  dispatch({ type: UPDATE_API_STATUS_REQUEST });
  await axiosClient
    .post(EndPoints.UPDATE_PRODUCTION_API_STATUS, data)
    .then((res) => {
      dispatch({ type: UPDATE_API_STATUS_SUCCESS });
      success(res);
    })
    .catch((err) => {
      dispatch({ type: UPDATE_API_STATUS_FAILED });
      console.log(err.response.data.message);
      setShowErrorMessage(err.response.data.message);
    });
};

export const RejectProductionRequests = async (
  dispatch,
  identifier,
  success,
  setShowErrorMessage
) => {
  await axiosClient
    .get(EndPoints.REJECT_PRODUCTION_REQUEST + "?identifier=" + identifier)
    .then((res) => {
      success(res);
    })
    .catch((err) => {
      console.log(err.response.data.message);
      setShowErrorMessage(err.response.data.message);
    });
};

export const CreateUser = async (
  dispatch,
  data,
  success,
  setShowErrorMessage
) => {
  dispatch({ type: CREATE_USER_REQUEST });
  await axiosClient
    .post(EndPoints.CREATE_USER, data)
    .then((res) => {
      dispatch({ type: CREATE_USER_SUCCESS });
      success(res);
    })
    .catch((err) => {
      dispatch({ type: CREATE_USER_FAILED });
      console.log(err.response.data.message);
      setShowErrorMessage(err.response.data.message);
    });
};

export const GetAllRoles = async (dispatch, success, setShowErrorMessage) => {
  await axiosClient
    .get(EndPoints.GET_ALL_ROLES)
    .then((res) => {
      success(res);
    })
    .catch((err) => {
      console.log(err.response.data.message);
      setShowErrorMessage(err.response.data.message);
    });
};

export const GetRMDashboardStatistics = async (
  dispatch,
  success,
  setShowErrorMessage,
  filter = ""
) => {
  let url = EndPoints.GET_ALL_STATISTICS_RM;
  await axiosClient
    .get(url)
    .then((res) => {
      success(res);
    })
    .catch((err) => {
      console.log(err.response.data.message);
      setShowErrorMessage(err.response.data.message);
    });
};

export const UpdateSupportStatus = async (
  dispatch,
  data,
  success,
  setShowErrorMessage
) => {
  await axiosClient
    .post(EndPoints.UPDATE_SUPPORT_STATUS, data)
    .then((res) => {
      success(res);
    })
    .catch((err) => {
      console.log(err.response.data.message);
      setShowErrorMessage(err.response.data.message);
    });
};

// Get Notification
export const GetNotification = async (
  success,
  setShowErrorMessage,
  isAll = "true"
) => {
  let url = EndPoints.GET_NOTIFICATION;

  if (isAll != "") {
    url = url + "?IsAll=" + isAll;
  }
  await axiosClient
    .get(url)
    .then((res) => {
      success(res);
    })
    .catch((err) => {
      const msg = err?.response?.data?.message || err?.message || "An error occurred";
      console.log(msg);
      setShowErrorMessage(msg);
    });
};

// Update Notification
export const UpdateNotification = async (
  dispatch,
  data,
  success,
  setShowErrorMessage
) => {
  const NotificationId = data.notificationId;
  await axiosClient
    .post(EndPoints.UPDATE_NOTIFICATION, null, { params: { NotificationId } })
    .then((res) => {
      success(res);
    })
    .catch((err) => {
      console.log(err.response.data.message);
      setShowErrorMessage(err.response.data.message);
    });
};

// Mark All Viewed Notification
export const MarkALLNotificationViewed = async (
  success,
  setShowErrorMessage
) => {
  await axiosClient
    .post(EndPoints.MARK_ALL_NOTIFICATION_VIEWED)
    .then((res) => {
      success(res);
    })
    .catch((err) => {
      console.log(err);
    });
};

// Get Notification Count

export const GetNotificationCount = async (success, setShowErrorMessage) => {
  let url = EndPoints.GET_NOTIFICATION_COUNT;
  await axiosClient
    .get(url)
    .then((res) => {
      success(res);
    })
    .catch((err) => {
      const msg = err?.response?.data?.message || err?.message || "An error occurred";
      console.log(msg);
      setShowErrorMessage(msg);
    });
};

// Get All Users Sandbox
export const GetAllUsersWithSandbox = async (
  dispatch,
  success,
  setShowErrorMessage,
  filter = "",
  role = "",
  status = "",
  sandboxstatus = ""
) => {
  let url = EndPoints.GET_ALL_USERS_WITH_SANDBOX;
  if (role != "" && status != "" && sandboxstatus != "") {
    url =
      url +
      "?role=" +
      role +
      "&status=" +
      status +
      "&sandboxstatus=" +
      sandboxstatus;
  }
  let params = {};

  if (filter != "") {
    params["filter"] = filter;
  }

  if (role != "") {
    params["role"] = role;
  }

  if (status != "") {
    params["status"] = status;
  }

  if (sandboxstatus != "") {
    params["sandboxstatus"] = sandboxstatus;
  }

  await axiosClient
    .get(url, { params })
    .then((res) => {
      success(res);
    })
    .catch((err) => {
      console.log(err.response.data.message);
      setShowErrorMessage(err.response.data.message);
    });
};

// Get All Users Sandbox Tech
export const GetAllUsersWithSandboxTech = async (
  dispatch,
  success,
  setShowErrorMessage,
  filter = "",
  role = "",
  status = "",
  sandboxstatus = "",
  techstatus = ""
) => {
  let url = EndPoints.GET_ALL_USERS_WITH_SANDBOX;
  if (role != "" && status != "" && sandboxstatus != "") {
    url =
      url +
      "?role=" +
      role +
      "&status=" +
      status +
      "&sandboxstatus=" +
      sandboxstatus +
      "&techstatus=" +
      techstatus;
  }

  let params = {};

  if (filter != "") {
    params["filter"] = filter;
  }

  if (role != "") {
    params["role"] = role;
  }

  if (status != "") {
    params["status"] = status;
  }

  if (sandboxstatus != "") {
    params["sandboxstatus"] = sandboxstatus;
  }

  if (techstatus != "") {
    params["techstatus"] = techstatus;
  }

  await axiosClient
    .get(url, { params })
    .then((res) => {
      success(res);
    })
    .catch((err) => {
      console.log(err.response.data.message);
      setShowErrorMessage(err.response.data.message);
    });
};

export const UpdateAPIStatusTech = async (
  dispatch,
  data,
  success,
  setShowErrorMessage
) => {
  dispatch({ type: UPDATE_API_STATUS_REQUEST });
  await axiosClient
    .post(EndPoints.UPDATE_API_STATUS_TECH, data)
    .then((res) => {
      dispatch({ type: UPDATE_API_STATUS_SUCCESS });
      success(res);
    })
    .catch((err) => {
      dispatch({ type: UPDATE_API_STATUS_FAILED });
      console.log(err.response.data.message);
      setShowErrorMessage(err.response.data.message);
    });
};

// Questionnaire
export const APIQuestionnaire = (
  dispatch,
  data,
  navigate,
  setShowErrorMessage,
  clearFields
) => {
  if (
    data.id &&
    data.userName &&
    data.apiIdentifier &&
    data.clientName &&
    data.dateofLive &&
    data.clearingArea &&
    data.assetClassesName &&
    data.msgsPerDayCount &&
    data.msgsPerSecond &&
    data.dateofLive &&
    data.serversHosting &&
    data.latencyRequirement &&
    data.systemType
  ) {
    axiosClient
      .post(EndPoints.QUESTIONNAIRE, data)
      .then((res) => {
        dispatch({ type: QUESTIONNAIRE_SUCESS, payload: res });
        navigate("/authentication/sign-up/success");
        clearFields();
      })
      .catch((err) => {
        dispatch({ type: QUESTIONNAIRE_FAILED });
        console.log(err.response.data.message);
        setShowErrorMessage(err.response.data.message);
      });
  } else {
    console.log("outside Hit");
  }
};

// Questionnaire Production
export const APIQuestionnaireProd = (
  dispatch,
  data,
  navigate,
  setShowErrorMessage,
  clearFields
) => {
  if (
    data.id &&
    data.userName &&
    data.apiIdentifier &&
    data.clientName &&
    data.dateofLive &&
    data.clearingArea &&
    data.assetClassesName &&
    data.msgsPerDayCount &&
    data.msgsPerSecond &&
    data.dateofLive &&
    data.serversHosting &&
    data.latencyRequirement &&
    data.systemType
  ) {
    console.log("inside Hit");
    axiosClient
      .post(EndPoints.QUESTIONNAIRE_PRODUCTION, data)
      .then((res) => {
        dispatch({ type: QUESTIONNAIRE_SUCESS, payload: res });
        clearFields();
      })
      .catch((err) => {
        dispatch({ type: QUESTIONNAIRE_FAILED });
        console.log(err);
        setShowErrorMessage(err);
      });
  } else {
    console.log("outside Hit");
  }
};

// Suppport User
export const SupportUserTickets = async (
  dispatch,
  success,
  setShowErrorMessage,
  filter = ""
) => {
  dispatch({ type: SUPPORT_USER_TICKETS });
  let url = EndPoints.SUPPORT_USER_TICKETS;
  if (filter != "") {
    url = url + "?filter=" + filter;
  }
  await axiosClient
    .get(url)
    .then((res) => {
      success(res);
    })
    .catch((err) => {
      console.log(err.response.data.message);
      setShowErrorMessage(err.response.data.message);
    });
};

// Onboard
export const OnboardingForm = async (success, setShowErrorMessage, id = "") => {
  let params = {};

  if (id != "") {
    params["id"] = id;
  }

  let url = EndPoints.ONBOARDING_FORM;

  await axiosClient
    .get(url, { params })
    .then((res) => {
      success(res);
    })
    .catch((err) => {
      setShowErrorMessage(err.message);
    });
};

export const RequestBulkAPISandbox = (
  dispatch,
  data,
  success,
  setShowErrorMessage
) => {
  if (data) {
    axiosClient
      .post(EndPoints.REQUEST_BULK_API_SANDBOX, data)
      .then((res) => {
        success(res);
      })
      .catch((err) => {
        setShowErrorMessage(err.response.data.message);
      });
  }
};

export const RequestDataDelete = (
  dispatch,
  data,
  success,
  failure,
  clearFields
) => {
  if (data.name && data.email) {
    dispatch({ type: CONTACT_US_REQUEST });
    axiosClient
      .post(EndPoints.REQUEST_DELETE_DATA, data)
      .then((res) => {
        dispatch({ type: CONTACT_US_SUCCESS });
        clearFields();
        success();
      })
      .catch((err) => {
        dispatch({ type: CONTACT_US_FAILED });
        failure(err.response.data.message);
      });
  }
};

// AuditTrail
export const GetAuditTrail = async (
  dispatch,
  success,
  setShowErrorMessage,
  options = {}
) => {
  const {
    filter = "",
    action = "",
    dateFrom = null,
    dateTo = null,
    entriesPerPage = 0,
    pageIndex = 0,
  } = options;
  let url = EndPoints.AUDIT_TRAIL;

  if (
    filter ||
    action ||
    dateFrom ||
    dateTo ||
    entriesPerPage ||
    pageIndex != ""
  ) {
    url =
      url +
      "?action=" +
      action +
      "&filter=" +
      filter +
      "&dateFrom=" +
      dateFrom +
      "&dateTo=" +
      dateTo +
      "&pageSize=" +
      entriesPerPage +
      "&pageIndex=" +
      pageIndex;
  }

  let params = {};

  if (filter != "") {
    params["filter"] = filter;
  }

  if (action != "") {
    params["action"] = action;
  }

  if (dateFrom != "") {
    params["dateFrom"] = dateFrom;
  }

  if (dateTo != "") {
    params["dateTo"] = dateTo;
  }

  if (entriesPerPage != "") {
    params["entriesPerPage"] = entriesPerPage;
  }

  if (pageIndex != "") {
    params["pageIndex"] = pageIndex;
  }

  await axiosClient
    .get(url, { params })
    .then((res) => {
      success(res);
    })
    .catch((err) => {
      console.log(err);
      setShowErrorMessage(err);
    });
};

// AuditTrail Download
export const GetAuditTrailDownload = async (
  dispatch,
  success,
  setShowErrorMessage,
  action = "",
  dateFrom = null,
  dateTo = null
) => {
  let url = EndPoints.AUDIT_TRAIL_DOWNLOAD;

  if (action || dateFrom || dateTo !== "") {
    url =
      url + "?action=" + action + "&dateFrom=" + dateFrom + "&dateTo=" + dateTo;
  }

  let params = {};

  if (action !== "") {
    params["action"] = action;
  }

  if (dateFrom !== "") {
    params["dateFrom"] = dateFrom;
  }

  if (dateTo !== "") {
    params["dateTo"] = dateTo;
  }

  await axiosClient
    .get(url, { params })
    .then((res) => {
      success(res);
    })
    .catch((err) => {
      console.log(err);
      setShowErrorMessage(err);
    });
};

export const SupportFilesDownload = async (
  dispatch,
  success,
  setShowErrorMessage,
  fileName
) => {
  let url = `${EndPoints.SUPPORT_FILE_DOWNLOAD}?fileName=${fileName}`;

  try {
    const res = await axiosClient.get(url, { responseType: "blob" });
    success(res);
  } catch (err) {
    console.log(err.message);
    setShowErrorMessage(err.message);
  }
};

export const SendEmailModal = (
  dispatch,
  data,
  config,
  success,
  setShowErrorMessage,
  clearFields
) => {
  dispatch({ type: SEND_EMAIL_MODAL });
  axiosClient
    .post(EndPoints.SEND_EMAIL_MODAL, data, config)
    .then((res) => {
      clearFields();
      success(res);
    })
    .catch((err) => {
      setShowErrorMessage(err.response.data.message);
    });
};

export const RecentEmailModal = (emailTo, isProduction) => {
  return new Promise((resolve, reject) => {
    if (emailTo) {
      console.log(emailTo);
      const params = new URLSearchParams({ emailTo, isProduction }).toString();
      axiosClient
        .get(EndPoints.RECENT_EMAIL_MODAL + "?" + params)
        .then((res) => {
          resolve(res.data); // Assuming response data contains the emails
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    } else {
      reject(new Error("No email specified"));
    }
  });
};

export const RecentEmailAttachementDownload = async (
  success,
  setShowErrorMessage,
  fileName
) => {
  let url = `${EndPoints.RECENT_EMAIL_ATTACHMENT_DOWNLOAD}?fileName=${fileName}`;

  try {
    const res = await axiosClient.get(url, { responseType: "blob" });
    success(res);
  } catch (err) {
    console.log(err.message);
    setShowErrorMessage(err.message);
  }
};
